import Login from "./components/Login";
import { connect } from "react-redux";
import { login } from "./actionCreators";
import type { StateProps, DispatchProps, OwnProps } from "./components/Login";

const mapStateToProps = (state, ownProps) => {
  return {
    ...ownProps,
    loading: state.user.isLoading,
    isAuthenticated: state.user.userState === "authenticated",
  };
};

const mapDispatchToProps = {
  login,
};
export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(Login);
